import { render } from "./BtnSolicitarSaque.vue?vue&type=template&id=9d283610&ts=true"
import script from "./BtnSolicitarSaque.vue?vue&type=script&lang=ts"
export * from "./BtnSolicitarSaque.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__